/* eslint-disable no-return-await, no-console, no-param-reassign, prefer-const */
import router from '@/router';

window.BASE_URL = process.env.VUE_APP_API_ROOT;

let VERBOSE_LOGGING = false; // log almost everything
let ALLOW_MOCK = false; // allow mocking
let FORCE_MOCK = false; // always send out mock data
let SIMULATE_SUCCESS_FALSE = false; // api testing force fail all (data.success = false)

// Configurable variables
VERBOSE_LOGGING = true;
ALLOW_MOCK = true;
// FORCE_MOCK = true;
// SIMULATE_SUCCESS_FALSE = true;
// End of configurable variables

const api = {
  path(path) {
    let baseURL = window.BASE_URL;
    if (localStorage.getItem('api_overwrite')) {
      baseURL = localStorage.getItem('api_overwrite');
    }
    const url = new URL(path, baseURL);
    return url.href;
  },
  mock(name, data) {
    console.info(`> Mocking data: ${name} > returning: ${JSON.stringify(data)}`);
    if (SIMULATE_SUCCESS_FALSE) {
      data.success = false;
      console.warn('IMPORTANT: SIMULATE_SUCCESS_FALSE flag in api.js is true, forcing data.success = false');
    }
    return { // simulate return data here
      status: 200,
      data,
    };
  },
  async call(name, mock, call) {
    if (FORCE_MOCK && Object.keys(mock).length > 0) {
      console.warn('IMPORTANT: FORCE_MOCK flag in api.js is true, forcing to mock data.');
      return api.mock(name, mock);
    }
    try {
      const result = await call();
      if (VERBOSE_LOGGING) {
        console.info(`Succeed in calling: ${name}`);
        console.log(result);
        console.log(result.data);
      }
      return result;
    } catch (e) {
      console.error(e);
      if (e.request && e.request.status === 404 && ALLOW_MOCK && Object.keys(mock).length > 0) {
        console.warn(`Can't reach api of '${name}', falling back to the mocked data.`);
        return api.mock(name, mock);
      }
      if (e.request && e.request.status === 401) {
        console.warn('You are unauthorized, please log in first');
        // return api.mock(name, mock);
        router.push({
          name: 'login',
          params: {
            forceLogout: true,
          },
        });
      }
      console.error(`API of '${name}' is not 404 and mocking is not allow`);
      throw e;
    }
  },
  dataMap(res, mapFn) {
    console.log(res.data.data);
    res.data.data = res.data.data.map(mapFn);
    return res;
  },
  dataFilter(res, filterFn) {
    // console.log(res.data.data);
    res.data.data = res.data.data.filter(filterFn);
    return res;
  },
};

export default api;
